import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import { FieldsSelector } from "@agricircle/shared/farms/components";
import { Subheading } from "@agricircle/shared/widgets";
import { displayErrorMessage } from "@agricircle/shared/redux";
import { useConfirm, useModal } from "@agricircle/shared/hooks";
import { useFarmApi } from "@agricircle/shared/farms/hooks";
import { selectFarm } from "@agricircle/shared/farms/redux";
import { KitStatus } from "../kit_status";
import { useSoilCarbonApi } from "../../hooks/soc";
import { SentinelStatus, SoilStatus } from "./soc_status";


export default () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { openModal } = useModal();
    const confirm = useConfirm();
    const farm = useSelector(selectFarm);
    const soilCarbonApi = useSoilCarbonApi();
    const farmApi = useFarmApi();
    const [kitParameters, setKitParameters] = useState({ area: 0, fieldIds: [] });
    const [kitStatus, setKitStatus] = useState();

    useEffect(() => {
        if (!farm?.id) return;
        soilCarbonApi.farmKitStatus(farm.id, setKitStatus);
    }, [farm?.id]);

    if (farm?.fields == null) return null;

    function onChangeFieldSelection(fieldIds) {
        const newParameters = { area: 0, fieldIds: [] };
        if (fieldIds.length > 0) {
            let unSelectable = false;
            farm.fields.forEach(f => {
                if (fieldIds.includes(f.id))
                    if (!f.soil || f.soil.properties?.includes("soc") || f.soil.recalculate) {
                        newParameters.fieldIds.push(f.id);
                        newParameters.area += f.area;
                    } else {
                        unSelectable = true;
                    }
            });
            if (unSelectable && fieldIds.length == 1)
                dispatch(displayErrorMessage(t("soc.no-soc-data")));
        }
        setKitParameters(newParameters);
        return newParameters.fieldIds;
    }

    function handlePrepareSoilCarbonKit() {
        confirm(
            t("soc.confirm-kit", { area: kitParameters.area.toFixed(1) }),
            () => {
                soilCarbonApi.prepareKit(farm.id, kitParameters.fieldIds, {}, setKitStatus);
            }
        );
    }

    const headers = [t("soc.column-name", kitParameters.area ? t("soc.column-selected-area", { area: kitParameters.area.toFixed(1) }) : t("soc.column-area"))];

    const actions = (f) => (<>
        <SentinelStatus sentinel={f.sentinel} />
        <SoilStatus soil={f.soil} property="soc" />
    </>);

    return (<>
        <Subheading title={t("soc.subtitle", { farmName: farm?.name || "" })}>
            <Button
                variant="contained"
                data-cy="button-prepare-soil-carbon-kit"
                onClick={handlePrepareSoilCarbonKit}
                disabled={kitParameters.area === 0 || Boolean(kitStatus)}>
                {t("soc.btn-prepare")}
            </Button>
        </Subheading >
        <KitStatus
            status={kitStatus}
            farmId={farm.id}
            kitStatusRequest={soilCarbonApi.kitStatus}
            kitCancelRequest={soilCarbonApi.cancelKit}
            onChange={setKitStatus}
        />
        <FieldsSelector
            fields={farm.fields}
            headers={headers}
            actions={actions}
            selected={kitParameters?.fieldIds || []}
            onChange={onChangeFieldSelection}
        />
    </>);
};
